import { type } from '@testing-library/user-event/dist/type';
import { handleRequest } from 'msw';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { HeaderComponent, FooterComponent, ExpectDialog, LoadingDialog } from '../../shared-component';
import { api } from '@utils/api';
import AppTool from '@/apps/@utils/app-tool';

const DEV_NEWS_TYPE = {
  FIRST_NEWS: 'first-news',
  NEWS: 'news',
  PLACARD: 'placard',
  ACTIVITY: 'activity'
}

const NewsPage = ({ item }) => {
  const MockNews = [
    {
      id: 1,
      title: 'News NewsNewsNewsNewsNewsNews',
      type: 'news',
      mainImage: window.assetUrl(`/images/news/news-main-default.png`),
      publish_at: '2021-09-01'
    },
    {
      id: 2,
      title: '【Placard】 NewsNewsNewsNewsNewsNewsNews',
      type: 'placard',
      mainImage: window.assetUrl(`/images/news/news-main-default.png`),
      publish_at: '2021-09-01'
    },
    {
      id: 3,
      title: 'News NewsNewsNewsNewsNews',
      type: 'news',
      mainImage: window.assetUrl(`/images/news/news-main-default.png`),
      publish_at: '2021-09-01'
    },
    {
      id: 4,
      title: '【Activity} NewsNews',
      type: 'activity',
      mainImage: window.assetUrl(`/images/news/news-main-default.png`),
      publish_at: '2021-09-01'
    },
    {
      id: 5,
      title: '【News】 NewsNewsNewsNewsNewsNews',
      type: 'news',
      mainImage: window.assetUrl(`/images/news/news-main-default.png`),
      publish_at: '2021-09-01'
    },
    {
      id: 6,
      title: '【News】 NewsNewsNewsNewsNewsNews',
      type: 'news',
      mainImage: window.assetUrl(`/images/news/news-main-default.png`),
      publish_at: '2021-09-01'
    }
  ];
  const navigate = useNavigate();
  const [newsList, setNewsList] = useState([]);
  const [newsShowList, setNewsShowList] = useState([]);
  const [currentShowIndex, setCurrentShowIndex] = useState(0);
  const [currentType, setCurrentType] = useState(null);
  const [pageNumCenterList, setPageNumCenterList] = useState([]);

  const [currentPage, setCurrentPage] = useState(null);
  const [firstNum, setFirstNume] = useState(1);
  const [lastNum, setLastNum] = useState(1);
  const [isPhone, setIsPhone] = useState(false);

  const isTypeUpdate = useRef(true);
  const isPageUpdate = useRef(true);

  const handleTypeChange = (type) => {
    console.log('handleTypeChange', type);
    setCurrentType((prevType) => type);
    if(type !== currentType && currentPage !== 1){
      setCurrentPage((prevPage) => 1);
    }

    let count = 0;
    let showList = [];
    for (let i = 0; i < newsList.length; i++) {
      if (newsList[i].type === type || type === DEV_NEWS_TYPE.FIRST_NEWS) {
        showList.push(newsList[i]);
        count++;
        if (count >= 6) {
          break;
        }
      }
    }
    console.log(showList);
    setNewsShowList(showList);
  }

  const handlePageChange = (page, tatol) => {
    if (tatol <= 3) {
      setFirstNume(null)
      setLastNum(null)
      let list = []
      for (let i = 1; i <= tatol; i++) {
        list.push(i)
      }
      setPageNumCenterList(list)
      setCurrentPage(page)
    }
    else if (tatol > 3 && tatol <= 5) {
      setFirstNume(1)
      setLastNum(5)
      let list = []
      for (let i = 2; i <= 4; i++) {
        list.push(i)
      }
      setPageNumCenterList(list)
      setCurrentPage(page)
    }
    else {
      setFirstNume(1)
      setLastNum(tatol)
      let list = []
      if (page == tatol || page == tatol - 1) {
        for (let i = tatol - 3; i <= tatol - 1; i++) {
          list.push(i)
        }
      }
      else if (page == 1 || page == 2) {
        for (let i = 2; i <= 4; i++) {
          list.push(i)
        }
      }
      else {
        list = [page - 1, page, page + 1]
      }
      setPageNumCenterList(list)
      setCurrentPage(page)
    }
  }

  const getNewsList = async (page, type) => {
    console.log('getNewsList', page, type);
    try {
      const res = await api.get(`/news-List-by-page?page=${page}&pageSize=6&type=${type == DEV_NEWS_TYPE.FIRST_NEWS ? 'all' : type}`);
      console.log(res.data.data)
      setNewsList(res.data.data.data);
      // 取得總頁數，取整數無條件進位
      const totalPage = Math.ceil(res.data.data.total / 6);
      handlePageChange(page, totalPage)
    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => { AppTool.closeLoadingDialog('.cLoadingDialog') }, 2000);
    }
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const type = urlParams.get('type')
    const page = urlParams.get('page')
    if(type && page){
      console.log(type, page);
      isPageUpdate.current = false;
      isTypeUpdate.current = false;
      setCurrentType((prevType) => type);
      setCurrentPage((prevPage) => page);
    }
    else{
      setCurrentType((prevType) => DEV_NEWS_TYPE.FIRST_NEWS);
      setCurrentPage((prevPage) => 1);
    }
    setIsPhone(window.innerWidth < 1040);
    window.addEventListener('resize', () => {
      setIsPhone(window.innerWidth < 1040);
    });
  }, []);

  useEffect(() => {
    if(currentPage){
      isPageUpdate.current = true;
      if (isTypeUpdate.current && isPageUpdate.current ) {
        getNewsList(currentPage, currentType);
      }
    }
   
  }, [currentPage]);

  useEffect(() => {
    if(currentType){
      isTypeUpdate.current = true;
      if (isTypeUpdate.current && isPageUpdate.current ) {
        getNewsList(currentPage, currentType);
      }
    }
  }, [currentType]);


  useEffect(() => {
    if(newsList && newsList.length > 0){
      handleTypeChange(currentType);
    }
  }, [newsList]);

  return (
    <div className="cNewsPage">
      <ExpectDialog />
      <HeaderComponent />
      <LoadingDialog />
      <img className="cTitle" src={window.assetUrl(`/images/news-page/${isPhone ? 'phone' : 'pc'}-title.jpg`)} alt="" />
      <div className='cControlBox'>
        <img className="cButton" src={window.assetUrl(`/images/news-page/first-news-${currentType == DEV_NEWS_TYPE.FIRST_NEWS ? 'on' : 'off'}.png`)} alt="" onClick={() => { handleTypeChange(DEV_NEWS_TYPE.FIRST_NEWS) }} />
        <img className="cButton" src={window.assetUrl(`/images/news-page/news-${currentType == DEV_NEWS_TYPE.NEWS ? 'on' : 'off'}.png`)} alt="" onClick={() => { handleTypeChange(DEV_NEWS_TYPE.NEWS) }} />
        <img className="cButton" src={window.assetUrl(`/images/news-page/placard-${currentType == DEV_NEWS_TYPE.PLACARD ? 'on' : 'off'}.png`)} alt="" onClick={() => { handleTypeChange(DEV_NEWS_TYPE.PLACARD) }} />
        <img className="cButton" src={window.assetUrl(`/images/news-page/activity-${currentType == DEV_NEWS_TYPE.ACTIVITY ? 'on' : 'off'}.png`)} alt="" onClick={() => { handleTypeChange(DEV_NEWS_TYPE.ACTIVITY) }} />
      </div>
      <div className='cContentBox'>
        <img className="cCircle1" src={window.assetUrl('/images/circle.png')} alt="" />
        <img className="cCircle2" src={window.assetUrl('/images/circle.png')} alt="" />

        <div className='cNewsBox'>
          <div className='cNewsSummary'>
            <img className="cFrame" src={window.assetUrl(`/images/news-page/${isPhone ? 'phone' : 'pc'}-news-fram.png`)} alt="" />
            <div className='cListBox'>
              {newsShowList.map((news, index) => (
                <div key={index} className='cNewsSummaryItem' onClick={() => { navigate(`/news/${news.id}?&type=${currentType}&page=${currentPage}`) }}>
                  <img className="cType" src={window.assetUrl(`/images/news/type-${news.type}.png`)} alt="" />
                  <div className='cTitleBox'>
                    <div className='cTitle'>{news.title}</div>
                    <div className='cDateBox'>
                      <img className="cDot" src={window.assetUrl(`/images/news-page/dot.png`)} />
                      <div className='cDate'>{news.publish_at}</div>
                    </div>
                  </div>
                </div>
              ))
              }
            </div>
          </div>
        </div>
        <div className='cPageNumber'>
          <img className="cPageNumberSeparate" src={window.assetUrl('/images/news-page/page-number-separate.png')} alt="" />
          <div className='cFirst'>
            <div className='cNum' onClick={() => { setCurrentPage(firstNum) }}>
              <img style={{ opacity: firstNum == currentPage ? 1 : 0 }} src={window.assetUrl('/images/news-page/page-number-current.png')} alt="" />
              <div className='cNumText'>{firstNum}</div>
            </div>
          </div>
          <div className='cCenter'>
            {pageNumCenterList.map((num, index) => (
              <div key={index} className='cNum' onClick={() => { setCurrentPage(num) }}>
                <img style={{ opacity: num == currentPage ? 1 : 0 }} src={window.assetUrl('/images/news-page/page-number-current.png')} alt="" />
                <div className='cNumText' >{num}</div>
              </div>
            ))
            }
          </div>
          <div className='cLast'>
            <div className='cNum' onClick={() => { setCurrentPage(lastNum) }}>
              <img style={{ opacity: lastNum == currentPage ? 1 : 0 }} src={window.assetUrl('/images/news-page/page-number-current.png')} alt="" />
              <div className='cNumText' >{lastNum}</div>
            </div>
          </div>
        </div>
      </div>
      <FooterComponent />
    </div>
  );
};

export default NewsPage;

